import { render, staticRenderFns } from "./CurriculumVitaeInfo.vue?vue&type=template&id=1b591cab&"
import script from "./CurriculumVitaeInfo.vue?vue&type=script&lang=js&"
export * from "./CurriculumVitaeInfo.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumVitaeInfo.vue?vue&type=style&index=0&id=1b591cab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports